import { PhysiotherapyOriginType } from "../model";

export function canUserAccessPhysioOriginType(physioOrigins: string[], physioOriginType: string) {
    return physioOrigins?.indexOf(physioOriginType) > -1;
}

export const canManagerSeePhysiotherapyReferral = (physioOrigins: string[]) => {
    return physioOrigins?.indexOf(PhysiotherapyOriginType.REFERRAL) > -1;
};
